export default "__VITE_ASSET__91e2bc70__"